module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"itemType":"Тип услуги","id":"Номер счета","date":"Дата","tariff":"Тариф"}}')
  delete Component.options._Ctor
}
